export const CGP_OBJECT_NAME = 'CGP';


